import { createStyles } from '@mantine/core'

type StylesParams = {
  showFull: boolean
  textWidth: number
  startCalc: boolean
  length: number
  opened: boolean | null
  numberToExpand: number
  iconSize: number
  padding: number
  touchSize: number
  bgColor: string
  bgColorCopyBtn: string
}

export default createStyles(
  (
    theme,
    {
      showFull,
      textWidth,
      startCalc,
      opened,
      numberToExpand,
      length,
      iconSize,
      touchSize: touchSizeProp,
      bgColor,
      bgColorCopyBtn,
    }: StylesParams,
  ) => {
    const borderRadius = 24
    const touchSize = Math.max(touchSizeProp, iconSize)
    const height = touchSize
    const baseWidth =
      textWidth + (showFull ? length + 1 : numberToExpand) * touchSize
    const restWidth = touchSize * (length - numberToExpand + 1)
    return {
      root: {
        position: 'relative',
        zIndex: 3,
      },
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: touchSize,
        backgroundColor: bgColor,
        borderRadius,
        ...(startCalc && {
          position: 'absolute',
          right: 0,
          bottom: 0,
          top: 0,
        }),
      },
      inner: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        paddingLeft: 6,
        transition: 'width .2s ease',
        height: '100%',
        [theme.fn.smallerThan('sm')]: {
          ...(!showFull && {
            overflow: 'hidden',
          }),
        },
        ...(baseWidth !== null && {
          width: opened ? baseWidth + restWidth : baseWidth - touchSize,
        }),
      },
      listItems: {
        display: 'flex',
        alignItems: 'center',
      },
      heading: {
        whiteSpace: 'nowrap',
        padding: '0 8px',
        fontSize: 10,
      },
      copyRoot: {
        position: 'relative',
        '&:has(input:disabled) .mantine-Input-rightSection': {
          display: 'block',
        },
      },
      copyHeading: {
        display: 'none',
      },
      copyInput: {
        '&:not(.mantine-Textarea-input)': {
          display: 'none',
        },
      },
      copyInputRightSection: {
        position: 'static',
        width: iconSize,
        height: iconSize,
      },
      copyInputWrapper: {},
      copyBtn: {
        borderRadius: '100%',
        height: iconSize,
        backgroundColor: bgColorCopyBtn,
      },
      item: {
        transition: 'width 0.3s ease',
        opacity: 1,
        width: touchSize,
        height: touchSize,

        'svg, img': {
          borderRadius: 4,
        },
        img: {
          flex: 0,
          width: 'auto !important',
          height: 'auto !important',
          maxWidth: iconSize,
          maxHeight: iconSize,
        },
        '.zalo-share-button': {
          position: 'absolute !important' as any,
          top: '50%!important' as any,
          left: '50%!important' as any,
          transform: 'translate(-50%,-50%)',
        },
      },
      itemInner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      frame: {
        ...(startCalc && {
          width: baseWidth,
          height,
        }),
      },
      controlBtn: {
        '&:active': {
          transform: 'translateY(0)',
        },
      },
      controls: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        borderBottomRightRadius: borderRadius,
        borderTopRightRadius: borderRadius,
        backgroundColor: bgColor,
      },
      overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255,255,255, 0.75)',
        zIndex: 2,
      },
    }
  },
)
